module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABaSURBVEiJ7dSxDYBADEPRH0QPQzECY94INxRMYJobwIdEg5wmjZOnNClJuFVVDUDSac9MAtcAdndmsbe/rAABAkABDTjM/Db6beb79xfkFwUI8ANgncz3WeABrxMYjg51pBEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/plus.png
// module id = 1429
// module chunks = 159